export const INSIGHTS_SORTABLE_FIELDS = [
  'priority',
  'expectedStartDateTime',
  'expectedFinishDateTime',
  'latestFinishDateTime',
] as const;

export const INSIGHTS_SORT_DIRECTIONS = ['asc', 'desc'] as const;
